import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CREATE_BUSINESS,
  UPDATE_BUSINESS,
  GET_BUSINESS_BY_SLUG_ID,
  GET_ALL_BUSINESSES,
} from "../../helpers/url_helper";

import { APIClient } from "../../helpers/api_helper";
const api = new APIClient();

const getAll = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const res = await api.get(
      `${process.env.REACT_APP_COMMON_URL}${GET_ALL_BUSINESSES}?${queryParams}`
    );

    if (res.status) {
    } else {
      toast.error(res.message, { theme: "colored" });
      // toast.error(res, { theme: "colored" });
    }
    return res;
  } catch (error) {
    toast.error(error, { theme: "colored" });
  }
};

const createBusiness = async (obj) => {
  // const id = toast.loading("Creating Post...", { autoClose: false });
  try {
    const res = await api.create(
      `${process.env.REACT_APP_COMMON_URL}${CREATE_BUSINESS}`,
      obj
    );

    if (res?.status) {
      toast.success(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    return res;
  } catch (error) {
    console.log(error)
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

const updateBusiness = async (obj) => {
  try {
    const res = await api.put(
      `${process.env.REACT_APP_COMMON_URL}${UPDATE_BUSINESS}/${obj.bussinessID}`,
      obj.data
    );

    if (res?.status) {
      toast.success(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    return res;
  } catch (error) {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

const getBusinessBySlugId = async (obj) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_COMMON_URL}${GET_BUSINESS_BY_SLUG_ID}/${obj}`
    );

    return res;
  } catch (error) {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

export const services = {
  getAll,
  createBusiness,
  updateBusiness,
  getBusinessBySlugId,
};
